import { render, staticRenderFns } from "./VDocumentCardArchivedFiles.vue?vue&type=template&id=55c0685d&lang=pug"
import script from "./VDocumentCardArchivedFiles.vue?vue&type=script&lang=ts"
export * from "./VDocumentCardArchivedFiles.vue?vue&type=script&lang=ts"
import style0 from "./VDocumentCardArchivedFiles.vue?vue&type=style&index=0&id=55c0685d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports